<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="modalCheck && !doOpen" id="alert_modal" class="modal-wrap">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_close"></div>
        <div class="header_txt"></div>
        <div class="header_close">
          <!-- <a rel="modal:close" class="close_modal" @click="closeModal()">
            <img src="../assets/images/icon/modal_close.png" alt="" />
          </a> -->
        </div>
      </div>
      <div class="modal_body">
        <!-- <div class="modal_contents">{{ resultValue }}</div> -->
        <!-- <div v-if="countdown > 0 && resultValue == ''" class="modal_contents"> -->
        <div
          v-if="(countdown > 0 || timerExpired) && resultValue == ''"
          class="modal_contents"
        >
          이메일 재전송 대기시간<br />
          <div class="formatTimer">{{ formattedTime }} <br /></div>
          이메일을 받지 못한 경우 재전송 대기시간 이후 다시 시도해주세요.
        </div>
        <!-- <div
          v-else-if="!countdown && resultValue"
          class="modal_contents"
          v-html="resultValue"
        ></div> -->
        <div v-else class="modal_contents" v-html="resultValue"></div>
      </div>
      <div class="modal_footer">
        <div v-if="!pwCPageChk && !checkAproFail" class="btn_area">
          <!-- <button @click="closeModal()" href="#close-modal" rel="modal:close" class="btn_basic">확인</button> -->
          <!-- MyPage에서 미로그인 접근시 발생하는 trigger -->
          <button
            v-if="errTriggerChk === 'onTrigger'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="movetoMain()"
          >
            확인
          </button>

          <!-- 위에꺼 정상작동확인함.. -->
          <!-- 로그인 ID/PW 페이지에서 사용함 -->
          <!-- PW찾기용 이메일 발송에서도 사용함. -->
          <button
            v-else-if="!approach"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
          <button
            v-else-if="timerSetting === 0"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
          <!-- <button
            v-else-if="trigger === 'onTrigger'"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="movetoMain()"
          >
            확인!@!@!@!~~~~~
          </button> -->
          <button
            v-else
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="approachErr()"
          >
            확인
          </button>
        </div>
        <div v-else-if="checkAproFail === 'ApproachFail'" class="btn_area">
          <button
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="aproFailCheck()"
          >
            확인
          </button>
        </div>
        <div v-else class="btn_area">
          <button
            v-if="!changeSucess"
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="closeModal()"
          >
            확인
          </button>
          <button
            v-else
            rel="modal:close"
            class="btn_basic"
            @click="moveLoginPage()"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="deleteRefUser" id="alert_modal" class="modal-wrap">
    <div class="modal-container">
      <div class="modal_header">
        <div class="header_close"></div>
        <div class="header_txt"></div>
        <div class="header_close">
          <!-- <a rel="modal:close" class="close_modal">
            <img src="../assets/images/icon/modal_close.png" alt="" />
          </a> -->
        </div>
      </div>
      <div class="modal_body">
        <div class="modal_contents" v-html="resultValue"></div>
        <!-- <div class="modal_contents">{{ resultValue }}</div> -->
      </div>
      <div class="modal_footer">
        <div class="btn_area">
          <button
            href="#close-modal"
            rel="modal:close"
            class="btn_basic"
            @click="endDeletAlert()"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
// import { deleteToken } from '../api/loginout'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    alertMsg: String,
    isOpen: Boolean,
    checkConfirm: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    pwCPage: String,
    changeSucess: Boolean,
    approach: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    failCheck: String,
    // eslint-disable-next-line vue/require-default-prop
    trigger: String,
    loadingDel: Boolean,
    isLoginPage: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    goBack: String,
    // eslint-disable-next-line vue/require-default-prop
    countdown: Number,
    // eslint-disable-next-line vue/require-default-prop
    // timerSetting: Number,
  },
  emits: ['update:isOpen', 'check:isLoginPage'],

  setup(props, { emit }) {
    const router = useRouter()

    const resultValue = ref('')
    const modalCheck = ref('')
    const doOpen = ref('')
    const pwCPageChk = ref('')
    const checkAproFail = ref('')
    const errTriggerChk = ref('')
    const deleteRefUser = ref('')
    const isLoginAlert = ref('')
    const checkGoBack = ref('')
    const timerSetting = ref('')
    const timerOn = ref(false)
    const timerExpired = ref(false) // 타이머 만료 여부를 추적하는 플래그 추가
    const formattedTime = ref('')
    watch(
      () => props.isOpen,
      () => {
        modalCheck.value = props.isOpen
        resultValue.value = props.alertMsg
        doOpen.value = props.checkConfirm
        pwCPageChk.value = props.pwCPage
        checkAproFail.value = props.failCheck
        errTriggerChk.value = props.trigger
        deleteRefUser.value = props.loadingDel
        isLoginAlert.value = props.isLoginPage
        checkGoBack.value = props.goBack
        timerSetting.value = props.countdown
      }
    )

    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${minutes}:${secs < 10 ? '0' : ''}${secs}` // 두 자리 수로 표시
    }
    const startTimer = () => {
      timerOn.value = true
      const timer = setInterval(() => {
        if (timerSetting.value > 0) {
          timerSetting.value -= 1
          formattedTime.value = formatTime(timerSetting.value) // 포맷팅된 시간 업데이트
        } else {
          clearInterval(timer)
          timerOn.value = false
          timerExpired.value = true
        }
      }, 1000)
    }
    // const startTimer = () => {
    //   timerOn.value = true
    //   const timer = setInterval(() => {
    //     if (timerSetting.value > 0) {
    //       timerSetting.value -= 1
    //     } else {
    //       clearInterval(timer)
    //       timerOn.value = false
    //       timerExpired.value = true
    //     }
    //   }, 1000)
    // }

    // watch로 timerSetting을 감시하고 0이 아니면 startTimer 실행
    watch(
      () => props.countdown,
      (newVal) => {
        timerSetting.value = newVal
        formattedTime.value = formatTime(timerSetting.value)
        timerExpired.value = false
        if (timerSetting.value > 0 && !timerOn.value) {
          startTimer()
        }
      }
    )

    const closeModal = () => {
      emit('update:isOpen', false)
    }
    const closeLoginModal = () => {
      emit('update:isOpen', false)
      emit('check:isLoginPage', false)
    }
    const moveLoginPage = () => {
      emit('update:isOpen', false)
      router.push({ name: 'LoginViews' })
    }
    const approachErr = () => {
      emit('update:isOpen', false)
      router.push({ name: 'FindPWViews' })
    }
    const movetoMain = () => {
      emit('update:isOpen', false)
      router.push({ name: 'IndexViews' })
    }
    const aproFailCheck = () => {
      emit('update:isOpen', false)
      // router.push('/')
      console.log('Redirecting to IndexViews') // 콘솔 로그 추가
      router.push('naver.com')
      // router.push({ name: 'IndexViews' })
    }
    const endDeletAlert = () => {
      emit('update:isOpen', false)
      router.push({ name: 'IndexViews' })
    }
    return {
      resultValue,
      modalCheck,
      doOpen,
      pwCPageChk,
      checkAproFail,
      errTriggerChk,
      deleteRefUser,

      closeModal,
      closeLoginModal,
      moveLoginPage,
      approachErr,
      aproFailCheck,
      movetoMain,
      endDeletAlert,
      timerSetting,
      timerExpired,
      formattedTime,
    }
  },
}
</script>

<style>
/* dimmed */
.modal-wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
}

.modal-container {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 550px;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem !important;
  border-radius: 1.25rem !important;
  z-index: 5;
}

.modal-container .modal_header {
  margin-bottom: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 5;
}

.modal-container .modal_header .close_modal {
  display: block !important;
  width: 1rem !important;
  height: 1rem !important;
  z-index: 5;
}

.modal-container .modal_header .close_modal img {
  width: 100%;
  z-index: 5;
}

.modal-container .modal_body {
  margin-bottom: 1.25rem;
  z-index: 5;
}

.modal-container .modal_body .modal_contents {
  text-align: center;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.4375rem;
  color: #2d2d2d;
  z-index: 5;
}
.modal-container .modal_body .modal_contents .formatTimer {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
  /* font-weight: bold; */
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.4375rem;
  color: #2d2d2d;
  z-index: 5;
}

.modal-container .modal_footer .btn_area {
  display: flex;
  gap: 0.5rem;
  z-index: 5;
}

.modal-container .modal_footer .btn_area button,
.modal-container .modal_footer .btn_area div {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 3.25rem;
  font-size: 1rem;
  font-weight: bold;
  z-index: 5;
}

.modal-container .modal_footer .btn_area .confirm_close {
  color: #2d2d2d;
  background-color: #dfdfdf;
  border: 1px solid #dfdfdf;
  z-index: 5;
}
</style>
